module.exports = __webpack_public_path__ + "static/media/lt-surge-5.5a0ff02f.wav";